import { CalculationModel } from '../models/calculation.model';
import { CalculationResultModel } from '../models/calculation-result.model';
import { CalculationOptionsModel } from '../models/calculation-options.model';
import { UserPublicInfoInterface } from '../interfaces/user-public-info.interface';
import { property } from '@pristine-ts/metadata';

export class CalculationResponse extends CalculationModel {
  @property()
  results?: CalculationResultModel;
  @property()
  options?: CalculationOptionsModel;
  @property()
  ownerInfo?: UserPublicInfoInterface;
}
